import copy from '~/content/marketing/ui'
export default {
  computed: {
    marketingCopy () { return copy[this.$i18n.locale] || copy.pl }
  }
}
